import {NgModel} from 'model/ngModel';

export const Webinar = NgModel.extend({
    _name: 'Webinar',
});
